import { checkIsButtonUrl } from 'core/utils/helpers/url';
import { useIsButtonEligibleForBrowser } from 'core/hooks/useIsButtonEligibleForBrowser';
import { useModalDetection } from 'core/modules/BonusButton/hooks/useModalDetection';
import config from 'core/modules/BonusButton/configs';

export const useCheckIsEligibleToFetchData = () => {
  const { isPageEligibleToShowModalOrPopup } = config;
  const isButtonPage = checkIsButtonUrl();
  const isPageEligibleToShow = isPageEligibleToShowModalOrPopup && !isButtonPage;

  const hasOpenModal = useModalDetection();
  const isButtonEligibleForBrowser = useIsButtonEligibleForBrowser();

  return isButtonEligibleForBrowser && isPageEligibleToShow && hasOpenModal === false;
};
